import DanaMenuItem from "@dana/Components/DanaMenu/DanaMenuPanelItem";
import { MappedLink } from "@insite/mobius/Menu";
import React from "react";

export type MenuPanelProps = {
    menuItems: MappedLink[];
};

const DanaMenuPanel = ({
    menuItems,
}: MenuPanelProps) => {
    return (
        <div className="menu-panel">
            {menuItems?.filter(item => !item.excludeFromNavigation)
                .map((item, index) => {
                    const hasChildren =
                        item.children?.some(o => !o.excludeFromNavigation)

                    if (
                        (item.type === "ChangeCustomerPage")
                    ) {
                        return null;
                    }

                    return (
                        <DanaMenuItem key={`${item.title}_${index}`} item={item} hasChildren={hasChildren} />
                    );
                })}

        </div>
    );
};

export default DanaMenuPanel;
